import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 mb-4" }
const _hoisted_3 = { class: "title-4 text-grey-800 mb-2" }
const _hoisted_4 = { class: "summary-wrapper bg-white px-3 pt-3 pb-2 p-sm-4 planning-bottom mt-4 shadow-4" }

import { ref, watch, onMounted, computed, toRef, nextTick } from "vue";
  import { useStore } from "vuex";
  import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes";
  
  // components
  import Fees from "@/vue/planning/components/summary/fees.vue";
  import Accommodations from "@/vue/planning/components/summary/accommodations.vue";
  import BorderHorizontal from "@/vue/common/borderHorizontal.vue";
  import Options from "@/vue/planning/components/summary/options.vue";
  import Total from "@/vue/planning/components/summary/total.vue";
  import BottomButtons from "@/vue/planning/components/summary/bottomButtons.vue";
  import StickySummary from "@/vue/planning/components/stickySummary.vue";
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'summary',
  props: {
    transition: { default: "height 250ms ease-in-out" }
  },
  setup(__props: any) {

  const store = useStore();
  
  // define props (transition only)
  const props = __props;
  
  // keep `transition` reactive using toRef
  const transition = toRef(props, "transition");
  
  // if there is no product available, don't show the summary
  const hideSummary = computed(() => {
	return Object.keys(store.getters.wiypCall).length === 0 || store.getters.totalSelectedHebergements === 0;
  });

  // compute the step number (3. or 4.)
  const stepNum = computed(() => {
	return (
	  availableTransportPackCodes.value.length > 0 &&
	  store.state.screenType === "desktop"
	)
	  ? "4. "
	  : "3. ";
  });
  
  // compute the first selected prestation variant
  const anySelectedVariant = computed(() => {
	const selected = store.getters.selectedPrestations;
	return selected && selected.length > 0 ? selected[0].prestation : undefined;
  });
  
  // reactive height for accordion
  const height = ref<string>("0px");
  const summary = ref<HTMLElement | null>(null);
  
  function expand() {
	if (!summary.value) return;
	height.value = summary.value.scrollHeight + "px";
	const onEnd = () => {
	  summary.value!.removeEventListener("transitionend", onEnd);
	  height.value = "";
	};
	summary.value.addEventListener("transitionend", onEnd);
  }
  
  function collapse() {
	height.value = "0px";
  }
  
  // group together the related watchers to handle summary expand/collapse
  watch(
	[
	  () => store.getters.totalSelectedHebergements,
	  () => Object.keys(store.getters.wiypCall).length > 0
	],
	async ([newHebergements, wiypReady], [oldHebergements, oldWiypReady]) => {
	  // Check if summary should expand
	  if (wiypReady && (!oldWiypReady || (newHebergements > 0 && oldHebergements === 0))) {
		await nextTick();
		expand();
	  }
	  // Check if summary should collapse
	  else if (!wiypReady || (newHebergements === 0 && oldHebergements > 0)) {
		collapse();
	  }
	},
	{ immediate: true }
  );
  
  // initialize collapsed on mount
  // onMounted(() => collapse());
  
return (_ctx: any,_cache: any) => {
  return (!hideSummary.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "summary",
        ref_key: "summary",
        ref: summary,
        class: "summary",
        style: _normalizeStyle({ height: height.value, transition: transition.value })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(stepNum.value) + _toDisplayString(_unref(store).state.content.planningSummary_sectionTitle), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(Accommodations),
              _createVNode(BorderHorizontal),
              _createVNode(Options, { variant: anySelectedVariant.value }, null, 8, ["variant"]),
              _createVNode(BorderHorizontal),
              _createVNode(Total),
              _createVNode(Fees),
              _createVNode(BottomButtons)
            ])
          ])
        ]),
        _createVNode(StickySummary)
      ], 4))
    : _createCommentVNode("", true)
}
}

})